import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import Resources from '@constants/resourses';

import { RestapiService } from '@services/restapi.service';
import { SessionService } from '@services/session.service';

@Component({
  selector: 'app-unsubscribe',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, MatFormFieldModule, MatInputModule],
  templateUrl: './unsubscribe.component.html',
  styleUrls: ['./unsubscribe.component.scss']
})
export class UnsubscribeComponent implements OnInit {
  isLoading: boolean = true;
  subscriptions: Subscription[] = [];

  emailFormGroup: FormGroup;
  emailId: string = '';
  isEmailManualEntry: boolean = false;
  isUnsubscribed: boolean = false;
  errordata: string = '';
  isSubmitted: boolean = false;

  // Not in use but kept for future reference
  isSmart: boolean;
  validateLoginRequest: any;
  isInputDisabled: boolean;

  constructor(
    private activiatedRoute: ActivatedRoute,
    private restAPI: RestapiService,
    private router: Router,
    private sessionService: SessionService,
    private formBuilder: FormBuilder
  ) {
    const emailregex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    
    if (this.activiatedRoute.snapshot.queryParams?.email) {
      this.emailId = decodeURIComponent(this.activiatedRoute.snapshot.queryParams?.email);
      // this.isSmart = this.activiatedRoute.snapshot.queryParams?.isSmart === 'true';
    }
    // Initialize the form group with email field
    this.emailFormGroup = this.formBuilder.group({
      email: [this.emailId || '', [Validators.required, Validators.pattern(emailregex)]],
    });

    this.isLoading = false;
  }

  ngOnInit(): void {
    // if (this.emailId) {
    //   const cPath = '/v1/users/validateLoginRequest/' + this.activiatedRoute.snapshot.queryParams?.token;
    //   this.subscriptions.push(
    //     this.restAPI.getAPI(cPath).subscribe({
    //       next: (data) => {
    //         if (data?.resultStatus === 'success') {
    //           this.isLoading = false;
    //           this.isInputDisabled = true;
    //           this.validateLoginRequest = data;
    //           this.isEmailManualEntry = false;
    //           this.emailId = this.validateLoginRequest?.data?.email;
    //           this.sessionService.setItemIntoLocal(Resources.SessionStorageKeys.Email, this.validateLoginRequest?.data?.email);
    //           this.emailFormGroup.patchValue({ email: this.validateLoginRequest?.data?.email });
    //         } else {
    //           this.isLoading = false;
    //           this.emailId = '';
    //           this.isInputDisabled = false;
    //           this.isEmailManualEntry = true;
    //         }
    //       }, error: (err) => {
    //         console.log('ERROR', err);
    //         this.isLoading = true;
    //         this.emailId = '';
    //         this.isInputDisabled = false;
    //         this.isEmailManualEntry = true;
    //       }
    //     })
    //   );
    // } else {
    //   this.isLoading = false;
    // }

    this.emailFormGroup.valueChanges.subscribe(() => {
      this.isEmailManualEntry = true;
      this.errordata = '';
    });
  }

  // Cancel
  cancel(): void {
    const queryParams = this.activiatedRoute.snapshot.queryParams;
    this.router.navigate(['home'], { queryParams: queryParams });
  }

  getErrorEmail() {
    const emailCtrl = this.emailFormGroup.get('email');
    if (emailCtrl.hasError('required')) {
      return 'Email address is required';
    }
    if (emailCtrl.hasError('pattern')) {
      return 'Not a valid email address';
    }
    return '';
  }

  // Unsubscribe
  result(): void {
    if (this.emailFormGroup.valid) {
      this.isSubmitted = true;
      this.emailId = this.emailFormGroup.get('email')?.value;
      this.unsubscribeMe();
    } else {
      this.emailFormGroup.markAllAsTouched();
    }
  }

  unsubscribeMe(): void {
    const cPath = `/v2/users/unsubscribe`;
    const bodyObj = {
      emailId: this.emailId,
      isEmailManualEntry: this.isEmailManualEntry,
      source: 'unsubscribe_page'
    }
    this.subscriptions.push(
      this.restAPI.patchAPI(cPath, bodyObj).subscribe(data => {
        if (data?.status === 'unsubscribed') {
          // reset email into localstorage
          this.sessionService.removeData(Resources.SessionStorageKeys.Email);
          this.sessionService.removeData(Resources.SessionStorageKeys.IsConsentApproval);
          this.isUnsubscribed = true;
        }
        this.isSubmitted = false;
      }, err => {
        console.log('ERROR: ', err);
        if (err?.error?.description === 'Already Unsubscribed') {
          this.sessionService.removeData(Resources.SessionStorageKeys.Email);
          this.sessionService.removeData(Resources.SessionStorageKeys.IsConsentApproval);
          this.isUnsubscribed = true;
        } else {
          this.isInputDisabled = false;
          this.isEmailManualEntry = true;
          this.errordata = err?.error?.description || err?.error || 'An error occurred while processing your request.';
        }
        this.isSubmitted = false;
      })
    );
  }

  // No longer needed: onKeydown, onKeyup (removed)
  gotoEnergyDashboard() {
    if (this.validateLoginRequest?.resultStatus === 'success') {
      const queryParams = this.activiatedRoute.snapshot.queryParams;
      this.router.navigate(['/information'], { queryParams: queryParams });

      this.sessionService.setData(Resources.SessionStorageKeys.Email, this.validateLoginRequest?.data?.email);
      this.sessionService.setData(Resources.SessionStorageKeys.IsConsentApproval, 'true');
      this.sessionService.setItemIntoLocal(Resources.SessionStorageKeys.IsLoggedIn, 'true');
      this.sessionService.setItemIntoSession(Resources.SessionStorageKeys.IsUserSubscribed, 'true');
      this.sessionService.setItemIntoSession(Resources.SessionStorageKeys.IsUserVisitedConsent, 'true')
      this.sessionService.setItemIntoSession(Resources.SessionStorageKeys.IsNotNow, 'false');
      this.sessionService.setItemIntoSession(Resources.SessionStorageKeys.IsSmart, 'true');
    } else {
      const queryParams = this.activiatedRoute.snapshot.queryParams;
      this.router.navigate(['service-unavailable'], { queryParams: queryParams });
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    })
  }
}
